"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadingOverlay = exports.LoadingContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactLoadingOverlay = _interopRequireDefault(require("react-loading-overlay"));
var _components = require("../address/components");
var _useTranslated = require("../../hooks/useTranslated");
var LoadingContainer = exports.LoadingContainer = _styledComponents["default"].div.withConfig({
  displayName: "components__LoadingContainer"
})(["display:flex;justify-content:center;align-items:center;& > div{padding:0;}"]);
var StyledLoader = (0, _styledComponents["default"])(_reactLoadingOverlay["default"]).withConfig({
  displayName: "components__StyledLoader"
})([".fileUpload_overlay{border-radius:3px;}&.fileUpload_wrapper--active{overflow:hidden;}"]);
var StyledLoadingText = _styledComponents["default"].span.withConfig({
  displayName: "components__StyledLoadingText"
})(["padding-left:5px;"]);
var UploadingOverlay = exports.UploadingOverlay = function UploadingOverlay(_ref) {
  var active = _ref.active,
    _ref$loadingText = _ref.loadingText,
    loadingText = _ref$loadingText === void 0 ? undefined : _ref$loadingText,
    children = _ref.children;
  var loadingTranslated = (0, _useTranslated.useTranslated)('fields.fileUpload.uploadingFiles');
  return /*#__PURE__*/_react["default"].createElement(StyledLoader, {
    active: active,
    classNamePrefix: "fileUpload_",
    spinner: /*#__PURE__*/_react["default"].createElement(LoadingContainer, null, /*#__PURE__*/_react["default"].createElement(_components.Loader, null), ' ', /*#__PURE__*/_react["default"].createElement(StyledLoadingText, null, loadingText ? loadingText : loadingTranslated))
  }, children);
};
UploadingOverlay.propTypes = {
  active: _propTypes["default"].bool,
  loadingText: _propTypes["default"].string
};